import {AbstractDTO} from '../abstract';
import {RuleDTO as Rule} from '../forms/rule';

export class Factor extends AbstractDTO {
    effectiveType: string;
    factorVal: number;
    factorValVar: string = '';
    rules: any[] = [];
    status: boolean = false;
    isIncludedInPrice: boolean = false;
    additionPrice: number = 0;
    updatedPrice: number = 0;
    calcFields: string[] = [];

    constructor(attributes?: object) {
        super(attributes);
        Object.assign(this, attributes);
        attributes = attributes ? attributes : {};
        this.effectiveType = attributes['effectiveType'];
        this.factorVal = parseFloat(attributes['factorVal']);
        this.factorValVar = attributes['factorValVar'] || '';
        this.calcFields = attributes['calcFields'] || [];
        this.rules = Rule.createFromArray(attributes['rules']) || [];
    }

}